module.exports = __webpack_public_path__ + "media/images/p-projectDetailsMain/arrow-effd6b6afb9b0186047a9e040be6ea5a.svg";